export const requiredMessage = 'Este campo es requerido';

export const emailMessage = 'Ingrese un email válido';
